import {
    Box,
    Typography,
    Grid,
    CircularProgress,
    IconButton
} from '@mui/material';
import dayjs from 'dayjs';
import HomeIcon from '@mui/icons-material/Home';
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import React, { useEffect, useMemo, useState } from 'react';
import { LoginActions } from '../../Services/_actions/LoginView/login.actions.ts';
import DynamicBreadcrumbs from '../Shared/Breadcrumb/index.tsx';
import { useNavigate } from 'react-router';
// import { LoginActions } from '../../Services/_actions/LoginView/login.actions';

const LoginLogs: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const actions = LoginActions();
    const [loginList, SetLoginList] = useState<any[]>([]);
    const navigate = useNavigate();


    useEffect(() => {
        getLoginView();
    }, []);

    const getLoginView = async () => {
        setIsLoading(true);
        try {
            const res = await actions.getLoginView();
            const processedData = (res?.status === 200 ? res?.data || [] : []).map(item => ({
                ...item,
                date: dayjs(item.login_timestamp).format('YYYY-MM-DD'),
                time: dayjs(item.login_timestamp).format('HH:mm:ss'),
            }));

            SetLoginList(processedData);
        } catch (error) {
            console.error("Error fetching login logs:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const breadcrumbsData = [
        { label: <IconButton color='primary'><HomeIcon /></IconButton>, href: "/" },
        { label: 'Login-Log-Details ' },
    ];

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'first_name',
                header: 'Name Of User',
                enableSorting: false,
                size: 200,
                muiTableHeadCellProps: {
                    sx: {
                        backgroundImage: 'linear-gradient(0deg, #3e59e3 35%, #5f76e8 100%)',
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '14px',
                        fontFamily:'system-ui',
                        paddingLeft: '35px !important', // header padding here
                    },
                },
                muiTableBodyCellProps: {
                    sx: {
                        paddingLeft: '35px !important',
                        backgroundColor: '#fafafa',
                    },
                },
            },


            {
                accessorKey: 'email',
                header: 'Email',
                enableSorting: false,
                size: 100
            },
            {
                accessorKey: 'organisation_name',
                header: 'Organisation',
                enableSorting: false,
                size: 150
            },
            {
                accessorKey: 'date',
                header: 'Date',
                enableSorting: false,
                size: 100
            },
            {
                accessorKey: 'time',
                header: 'Time',
                enableSorting: false,
                size: 20
            },
        ],
        []
    );

    return (
        <Box sx={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
            <DynamicBreadcrumbs items={breadcrumbsData} onBreadcrumbClick={(event, item: { label: string, href: string }) => {
                if (item) {
                    navigate(item?.href);
                }
            }}
            />
            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', pb: 1.3 }}>
                        Login Log Details
                    </Typography>
                </Grid>
            </Grid>
            <MaterialReactTable
                columns={columns}
                data={loginList}
                muiTableBodyCellProps={{
                    sx: (theme) => ({
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
                    }),
                }}
                muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 190px)', width: '100%' } }}
                muiTableHeadCellProps={{
                    sx: {
                        backgroundImage: 'linear-gradient(0deg, #3e59e3 35%, #5f76e8 100%)',
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '14px',
                        fontFamily:'system-ui',
                    },
                }}
                state={{
                    showColumnFilters: false,
                    isLoading
                }}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableColumnActions={false}
                enableColumnFilters={false}
                enableHiding={false}
                enableStickyHeader={true}
                enableTopToolbar={false}
                enableBottomToolbar={false}
                initialState={{
                    density: 'comfortable',
                }}
                enablePagination={false}
            />
        </Box>
    );
};

export default LoginLogs;
